import { Outlet } from "react-router";
import { NativeBridge } from "@/features/auth/NativeBridge";
import { WebPushBridge } from "@/features/auth/WebPushBridge";

/**
 * Outermost route element. NativeBridge lives here, above both AppShell and
 * AuthShell, so the Capacitor deep-link listener exists on every route: the
 * Garmin callback (`pbranks://pbranks.com/auth/garmin?code=…`) arrives while a
 * logged-out user is on the /auth login page, where AppShell is not mounted
 * (#371).
 */
export function RootLayout() {
  return (
    <>
      <NativeBridge />
      <WebPushBridge />
      <Outlet />
    </>
  );
}
